import { render, staticRenderFns } from "./UnSubscribe.vue?vue&type=template&id=d990f1d8&"
import script from "./UnSubscribe.vue?vue&type=script&lang=js&"
export * from "./UnSubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports